class Customer {
	constructor(id, type, offerPrice, negotiatedPrice, productName, productType, state) {
		this.id = id;
		this.type = type;
		this.offerPrice = offerPrice;
		this.negotiatedPrice = negotiatedPrice;
		this.productName = productName;
		this.productType = productType;
		this.state = state;
	}
	
	toPlainObj() {
		return {
			id: this.id,
			type: this.type,
			offerPrice: this.offerPrice,
			negotiatedPrice: this.negotiatedPrice,
			productName: this.productName,
			productType: this.productType,
			state: this.state,
		};
	}
}

export default function CustomerBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withType: function (type) {
			this.type = type;
			return this;
		},
		withOfferPrice: function (offerPrice) {
			this.offerPrice = offerPrice;
			return this;
		},
		withNegotiatedPrice: function (negotiatedPrice) {
			this.negotiatedPrice = negotiatedPrice;
			return this;
		},
		withProductName: function (productName) {
			this.productName = productName;
			return this;
		},
		withProductType: function (productType) {
			this.productType = productType;
			return this;
		},
		withState: function (state) {
			this.state = state;
			return this;
		},
		build: function () {
			return new Customer(
				this.id, 
				this.type, 
				this.offerPrice, 
				this.negotiatedPrice, 
				this.productName, 
				this.productType,
				this.state,
			);
		}
	};
}
